import React from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';
import options from './options.json';

/**
 * DocumentTypeFormコンポーネント用のPropsです。
 * @interface DocumentTypeFormProps
 */
interface DocumentTypeFormProps {
  /**
   * 書類名称
   * @type {InputFieldState}
   * @memberof DocumentTypeFormProps
   */
  documentName: InputFieldState;

  /**
   * 書類名称を設定する関数
   * @memberof DocumentTypeFormProps
   */
  onChange: (documentName: InputFieldState) => void;
}

/**
 * 書類名称フォームのコンポーネントです。
 * @param {InputFieldState} props.docmentTypeName - チェック済みにする書類名称
 * @param {function} props.onChange - 書類名称が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 書類名称フォームのJSX要素
 */
const DocumentTypeForm: React.FC<DocumentTypeFormProps> = ({ documentName, onChange }) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 選択された書類名称で、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      value: event.target.value,
      errorMessage: ''
    });
  };

  return (
    <Form.Group className="mb-3 row">
      <Form.Label className="col-lg-2 col-12 d-flex align-items-center">
        書類種別
        <span className="text-small text-danger ms-3">※必須</span>
      </Form.Label>
      <div className="col-lg-10 col-12 ps-lg-5">
        {
          options.map((option, index) => {
            return (
              <Form.Check
                key={index}
                type="radio"
                className="form-check-inline"
                value={option.value}
                label={option.label}
                id={`documentType${index}`}
                checked={documentName.value === option.value}
                onChange={handleChange}
              />
            );
          })
        }
      </div>
    </Form.Group>
  );
}

export default DocumentTypeForm;